/* RESPONSIBLE TEAM: team-proactive-support */
import { inject as service } from '@ember/service';
import ContentEditorRoute from 'embercom/routes/apps/app/content/edit';
import { objectTypes } from 'embercom/models/data/matching-system/matching-constants';
export default ContentEditorRoute.extend({
  store: service(),
  analytics: {
    section: 'messages',
    place: 'sms_editor',
  },

  async afterModel() {
    this.outboundHomeService.setActiveList(objectTypes.sms);
    await this.store.findAll('sms/phone-number');
  },
});
